import script from "./HeaderParalympic.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderParalympic.vue?vue&type=script&setup=true&lang=js"

import "./HeaderParalympic.vue?vue&type=style&index=0&id=a4a0dbe0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4a0dbe0"]])

export default __exports__